<template>
  <q-field
    :error="errors.has('currency')"
    :error-label="errors.first('currency')"
    :label="!floatingLabel ? label : null"
    :labelWidth="labelWidth"
  >
    <q-select
      v-validate.disable="'required|currency'"
      data-vv-name="currency"
      :float-label="floatingLabel ? label : null"
      :placeholder="$t('currency')"
      :options="currencyOptions"
      :value="value"
      :disable="disable"
      @input="_emit"
    ></q-select>
  </q-field>
</template>

<script>
  import currencies from './currencies.json'

  export default {
    inject: ['$validator'],

    props: {
      value: {
        type: String,
        required: true
      },

      label: {
        required: false,
        type: String,
        default: null
      },

      labelWidth: {
        type: Number,
        default: null
      },

      floatingLabel: {
        type: Boolean,
        required: false,
        default: false
      },

      disable: {
        type: Boolean,
        required: false,
        default: false
      },

      displayAllCurrencies: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    computed: {
      currencyOptions () {
        return currencies
      }
    },

    methods: {
      _emit (newVal) {
        this.$emit('input', newVal)
      }
    }
  }
</script>
